var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmallXIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 0C3.91797 0 0 3.91797 0 8.75C0 13.582 3.91797 17.5 8.75 17.5C13.582 17.5 17.5 13.582 17.5 8.75C17.5 3.91797 13.582 0 8.75 0ZM11.9805 12.0742L10.6914 12.0684L8.75 9.75391L6.81055 12.0664L5.51953 12.0723C5.43359 12.0723 5.36328 12.0039 5.36328 11.916C5.36328 11.8789 5.37695 11.8438 5.40039 11.8145L7.94141 8.78711L5.40039 5.76172C5.37679 5.73309 5.36369 5.69725 5.36328 5.66016C5.36328 5.57422 5.43359 5.50391 5.51953 5.50391L6.81055 5.50977L8.75 7.82422L10.6895 5.51172L11.9785 5.50586C12.0645 5.50586 12.1348 5.57422 12.1348 5.66211C12.1348 5.69922 12.1211 5.73438 12.0977 5.76367L9.56055 8.78906L12.0996 11.8164C12.123 11.8457 12.1367 11.8809 12.1367 11.918C12.1367 12.0039 12.0664 12.0742 11.9805 12.0742Z",
    fill: "#BABABA"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallXIc);
export default __webpack_public_path__ + "static/media/small_x_ic.fb718f889e329b76fd4e672315765df9.svg";
export { ForwardRef as ReactComponent };